import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

function useAndroidSafeArea() {
    const [cookies] = useCookies(['androidTopPadding']);
    const { androidTopPadding } = cookies;
    useEffect(() => {
        if (androidTopPadding) {
            document.documentElement.style.setProperty('--safe-area-top', `${androidTopPadding}px`);
        }
    }, [androidTopPadding]);
}

export default useAndroidSafeArea;
